import http from "@/utils/axios";
import cookie from "@/utils/cookie";

const state = {
  eimsCodes: [],
  codesTree: [],

}

const mutations = {

  queryCodeDict(state){
    let token = cookie.getCookie("token")
    let obj = {
      token : token
    };
    http.post(window.config.api.baseUrl + '/eims-api/code/queryCodeDict',obj).then( response => {
      if (response.data.code == '00000') {
        state.eimsCodes = response.data.data.eimsCodes
        state.codesTree = response.data.data.codesTree
      }
    })
  }
}

const actions = {
  queryCodeDict:({commit, state}, obj) => commit("queryCodeDict"),

}

export default {
  state, mutations, actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/codeDictModule.js